import styled, { css } from 'styled-components';

export const inputBase = `
  display: block;
  width: 100%;
  border: none;
  outline: none;
`;

interface InputLinedSC {
  variation: 'lined' | 'round' | 'table';
  error?: React.ReactNode;
  disabled?: boolean;
  ref?: React.Ref<unknown>;
}

export const InputSC = styled.div<InputLinedSC>`
  position: relative;
  display: flex;
  align-items: center;

  input {
    ${inputBase};
    padding-left: 8px;
    ${({ variation, error }) => {
      switch (variation) {
        case 'lined':
          return css`
            background: transparent;
            border-bottom: ${error
              ? '1px solid #ff335c'
              : '1px solid rgba(51, 61, 108, 0.4)'};
            height: 40px;

            &:hover,
            &:active,
            &:focus {
              border-bottom: ${error
                ? '1px solid #ff335c'
                : '1px solid rgba(51, 61, 108, 1)'};
            }
          `;
        case 'round':
          return css`
            background: rgba(202, 204, 216, 0.3);
            border-radius: 8px;
            padding: 0px 10px;
            height: 40px;
            ${error &&
            css`
              border: 1px solid #ff335c;
            `}
          `;
        case 'table':
          return css`
            background: transparent;
            border: 1px solid rgba(202, 204, 216, 0.6);
            border-radius: 10px;
            padding: 8px 12px;
          `;
        default:
          return '';
      }
    }}

    color: #333d6c;
    font-weight: 400;
    font-size: 14px;

    &::-webkit-input-placeholder,
    &::-moz-placeholder,
    &:-ms-input-placeholder,
    &:-moz-placeholder {
      opacity: 0.4;
    }

    ${({ disabled }) =>
      disabled
        ? `
        border-color: #D7D9E2;
        color: rgba(24, 30, 52, 0.4);
      `
        : ''}
  }

  .clear-icon {
    position: absolute;
    top: 35%;
    right: 0;
    margin-right: 15px;
    margin-bottom: 1px;
    cursor: pointer;
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;

    img {
      width: 10px;
      height: 10px;
    }

    &:hover {
      opacity: 0.5;
    }
  }
`;
